import React from "react";
 
import Navbar from "../components/homepage/Navbar";
import PartsManufacturerLandingPage from "../components/enterpriseDealerPage/PartsManufacturerLandingPage";
import { Header, Footer } from "../shared";

const EnterpriseDealerPage = () => {
  window.scrollTo(0, 0);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      {/* <EnterpriseDealerHero /> */}
      {/* <WhyEnterprise /> */}
      <PartsManufacturerLandingPage />
      {/* <EnterpriseNeedMoreInfo /> */}
      <Footer />
    </div>
  );
};

export default EnterpriseDealerPage;
